import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '../components/SkuViewed/Context';
import type { TooltipActionType } from '../types';
import { usePageAction } from './usePageAction';
export function useDriverTooltipPageAction(t0) {
  const $ = _c(8);
  const section = t0 === undefined ? "roundup_recommendations" : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function getAnalyticsDriverActionName(driverLabel) {
      return `quick_fact_value_tooltip_${driverLabel.toLowerCase().split(" ").join("")}`;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getAnalyticsDriverActionName = t1;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t2;
  if ($[1] !== skuImpressionId) {
    t2 = {
      sku_impression_id: skuImpressionId
    };
    $[1] = skuImpressionId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== section || $[4] !== t2) {
    t3 = {
      actionName: "",
      actionSection: section,
      additionalAttributes: t2
    };
    $[3] = section;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const firePageAction = usePageAction(t3);
  let t4;
  if ($[6] !== firePageAction) {
    const fireTooltipPageAction = (actionName, actionType) => {
      firePageAction({
        action_name: actionName,
        action_type: actionType
      });
    };
    t4 = (driverLabel_0, actionType_0) => {
      fireTooltipPageAction(getAnalyticsDriverActionName(driverLabel_0), actionType_0);
    };
    $[6] = firePageAction;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleTooltipClickPageAction = t4;
  return handleTooltipClickPageAction;
}